/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line

import { Divider, Button, Popconfirm, message } from 'antd'

// import SimplePopover from '../../../components/SimplePopover'

import { userCertStore } from '../../../store/list/UserCertModel'
import { userAction } from '../../../action/user'

const onChangeAuthStatus = (uid: any, action: string) => {
  userAction.setAuthStatus(uid, action)
    .then(responseData => {
      message.info('设置审核状态成功')
      userCertStore.reloadCurrentPage()
    })
    .catch((err) => {
      message.warning(err.message)
    })
}

export default (props: { text: any, record: any }) => {
  return <span>
    <Button type="primary" size="small" onClick={() => { onChangeAuthStatus(props.record.id, 'pass') }}>通过</Button>
    <Divider type="vertical" />
    <Popconfirm
      title="确认拒绝审核请求吗?"
      onConfirm={() => { onChangeAuthStatus(props.record.id, 'deny') }}
      okText="是"
      cancelText="否"
    >
      <Button type="danger" size="small">拒绝</Button>
    </Popconfirm>
  </span>
}
